module.exports = __webpack_public_path__ + "media/images/emblems/Gottlieben-e3380baef4c79fcdd5004d5356de254f.GIF";